import React from 'react';
import { Icon } from '../../../concepts/resources/Icon';
import { Tip } from '../../../ui/Tip';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export const IncognitoWidget = () => {
    return <Flexer >
        <Tip position="left" text="Participant list is disabled when Hide Identities is enabled.">
            <Icon src="deqo://icons/meeting/anonymous" size="3" />
        </Tip>
    </Flexer>;
};
